import { render, staticRenderFns } from "./CaseDetailInfo.vue?vue&type=template&id=ebe4ddd6&scoped=true&"
import script from "./CaseDetailInfo.vue?vue&type=script&lang=js&"
export * from "./CaseDetailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe4ddd6",
  null
  
)

export default component.exports